import api from "./Api";

class ChatGPTService {
  GetChat(payload) {
    return api.get("/v1/ChatGPT/Chat?chat=" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ChatGPTService();
